/** Titel/Anreden, die beim Extrahieren des Nachnamens übersprungen werden. */
const NAME_TITLE_RE =
  /^(dr\.?|prof\.?|dipl\.?-?ing\.?|dipl\.?|ing\.?|mag\.?|med\.?|herr|frau|mr\.?|mrs\.?|ms\.?|sir|lady)$/i;

const normalizeComparable = (value) =>
  String(value || '')
    .trim()
    .replace(/\s+/g, ' ')
    .toLowerCase();

/**
 * True, wenn „Name“ und „Unternehmen“ denselben Text haben
 * (typisch bei Firmensuche: Kontakt = Firma → Anrede „Damen und Herren“).
 */
export function isCompanyAsContactName(name, company) {
  const n = normalizeComparable(name);
  const c = normalizeComparable(company);
  return Boolean(n && c && n === c);
}

/**
 * Liefert den Nachnamen aus einem vollständigen Namen.
 * - „Vorname Nachname“ → Nachname
 * - „Nachname, Vorname“ → Nachname
 * - einzelne Titel (Dr., Prof. …) werden übersprungen
 */
export function extractLastName(fullName = '') {
  const cleaned = String(fullName || '')
    .replace(/\s+/g, ' ')
    .trim();
  if (!cleaned) return '';

  if (cleaned.includes(',')) {
    const beforeComma = cleaned.split(',')[0].trim();
    if (beforeComma) {
      const parts = beforeComma.split(' ').filter(Boolean);
      return parts[parts.length - 1] || beforeComma;
    }
  }

  const parts = cleaned.split(' ').filter(Boolean);
  const withoutTitles = parts.filter((p) => !NAME_TITLE_RE.test(p.replace(/,$/, '')));
  const tokens = withoutTitles.length ? withoutTitles : parts;
  return tokens[tokens.length - 1] || '';
}
